import { SerializedStyles } from '@emotion/react'
import styled from '@emotion/styled'
import Chip from '@mui/material/Chip'
import { memo } from 'react'
import { goToSearchPage } from '../../actions/nav'
import { AppRouter } from '../../state/state.router'
import { updateSearchQuery } from '../../state/state.search'
import { getThemeSpacing } from '../styles/appTheme'
import { palette } from '../styles/colors'

const StyledRoot = styled('div')({
    font: 'inherit',
    justifyContent: 'space-between',
    marginTop: getThemeSpacing(4),
    alignItems: 'center',
    flexWrap: 'wrap',
    display: 'flex',
    flexShrink: 0,
    width: '100%',
})

const StyledChip = styled(Chip)({
    font: 'inherit',
    padding: `0 ${getThemeSpacing(0.5)}`,
    marginBottom: getThemeSpacing(),
    background: palette.tagsBackground,
    color: palette.tagsColor,
    fontWeight: 500,
    fontSize: 13,
    border: `1px solid ${palette.tagsBorder}`,
    cursor: 'pointer',
    '&:hover': {
        background: palette.tagsBorder,
    },
})

interface ITags {
    onClick?(): void
    styleOverrides?: SerializedStyles
    tags: string[]
}

const Tags = (props: ITags) => {
    const { tags = [], onClick = () => {}, styleOverrides } = props
    const tagClick = (tag) => () => {
        updateSearchQuery({
            external: true,
            type: 'tags',
            search: tag,
        })

        if (AppRouter.route.visiblePage !== 'search') {
            goToSearchPage({ query: tag, type: 'tags' })
        }

        onClick()
    }
    return (
        <StyledRoot css={styleOverrides}>
            {(tags ? tags : []).map((tag: string, index: number) => (
                <StyledChip
                    key={`${index}-${tag}`}
                    onClick={tagClick(tag)}
                    data-testid="Chip__Tag"
                    {...(index === 0 ? { style: { marginLeft: 0 } } : {})}
                    label={tag}
                />
            ))}
        </StyledRoot>
    )
}

export default memo(Tags)
